export const SET_CART_MODE = 'SET_CART_MODE';

export type CartMode = 'checkout' | 'cart';

export interface AnalyticsState {
  cartMode: CartMode;
}
